import { SocketMessage } from '../../core/websocket/websocket.models';
import { SocketConnectionStatus } from '../../core/websocket/websocket.models';

export interface SocketState {
  status: SocketConnectionStatus;
  error: string | null;
  lastMessage: SocketMessage | null;
  channels: string[];
}

export const initialSocketState: SocketState = {
  status: 'disconnected',
  error: null,
  lastMessage: null,
  channels: [],
};